import script from "./ElaSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ElaSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ElaSidebar.vue?vue&type=style&index=0&id=ff879f40&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ELA/ELA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff879f40"]])

export default __exports__